export default "__VITE_ASSET__6b1e3cc2__"